import React, { Fragment, useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import logo from "../assets/axis-backoffice.svg";
import { Link } from "react-router-dom";
import Button from "react-bootstrap/Button";
import { NavModal } from "../modals/NavModal";
import { Container, Card } from "react-bootstrap";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { GiHamburgerMenu } from "react-icons/gi";
import { selectedApiUrl, useAuth } from "../context/AuthContext";
import Dropdown from "react-bootstrap/Dropdown";
import { BsPersonFill, BsQuestionCircle, BsWhatsapp, BsEnvelope } from "react-icons/bs";
import { BiSolidLogOut } from "react-icons/bi";
import { UserNotificationIcon } from "../components/UserNotificationIcon";
import { LayoutProvider, useLayout } from "../context/LayoutContext";

const BaseTemplateInner = ({ props, content }) => {
  const { logout, authAxios } = useAuth();
  const { sidebarHidden } = useLayout();
  const year = new Date().getFullYear();
  const [user, setUser] = useState(null);
  const [visible, setVisible] = useState(false);
  const [devProd, setDevProd] = useState(false);

  const packageJson = require("../version.json");
  const buildVersion = packageJson.version;
  const apiUrl = selectedApiUrl();

  useEffect(() => {
    if (
      apiUrl.includes("axisagency.co.uk") &&
      buildVersion.endsWith("SNAPSHOT")
    )
      setDevProd(true);
    fetchCurrentUser();
  }, []);

  const fetchCurrentUser = async () => {
    try {
      const config = {
        headers: {
          "content-type": "application/json",
        },
        params: {},
      };

      const response = await authAxios().get(
        "/api/backoffice/users/current_user",
        config,
      );

      setUser(response.data);
    } catch (error) {
      console.log("Error catch");
      console.log(error);
    }
  };

  const getUserDropDownText = () => {
    if (
      user?.forename === null ||
      user?.forename === undefined ||
      user?.forename === "" ||
      user?.surname === null ||
      user?.surname === undefined ||
      user?.surname === ""
    )
      return "";
    return (
      user?.forename[0].toUpperCase() + " " + user?.surname[0].toUpperCase()
    );
  };

  return (
    <div className="d-flex flex-column vh-100">
      <header style={devProd ? { backgroundColor: "hotpink" } : null}>
        <Container fluid className={"m-0 p-0 ps-3 mb-3 align-content-center"}>
          <Row className={"w-100 align-items-center m-0 p-0 mt-1"}>
            <Col className={"d-sm-none"}>
              <Button
                className={"hamburger"}
                onClick={() => setVisible(!visible)}
              >
                <GiHamburgerMenu size={28} />
              </Button>
            </Col>
            <Col id={"logo-wrapper"} className={"m-0 p-0"}>
              <Link to={"/"}>
                <img src={logo} alt={"Axis Healthcare"} />
              </Link>
            </Col>
            <Col>
              <Row
                xs={"auto"}
                className={"align-items-center justify-content-end"}
              >
                <Col>
                  <Dropdown>
                    <Dropdown.Toggle
                      variant="outline-primary"
                      size="sm"
                      className="d-flex align-items-center"
                    >
                      <BsQuestionCircle className="me-1" size={25} />
                        Get Support
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item
                        href="https://chat.whatsapp.com/EIcQMzZ6aESL4RDKLg8Aj5"
                        target="_blank"
                        className="d-flex align-items-center"
                      >
                        <BsWhatsapp className="me-2" />
                        Axis App Support Channel
                      </Dropdown.Item>
                      <Dropdown.Item
                        href="mailto:herron.philip@googlemail.com"
                        className="d-flex align-items-center"
                      >
                        <BsEnvelope className="me-2" />
                        Direct Email Support
                      </Dropdown.Item>
                      <Dropdown.Item
                        href="https://wa.me/447769309263"
                        target="_blank"
                        className="d-flex align-items-center"
                      >
                        <BsWhatsapp className="me-2" />
                        Philip's Direct WhatsApp
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </Col>
                  <UserNotificationIcon user={user} />
                <Col>
                  <Dropdown>
                    <Dropdown.Toggle
                      className={"circle-settings"}
                      variant={"offblack"}
                      id="dropdown-basic"
                    >
                      {getUserDropDownText()}
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item disabled>
                        <p className={"text-axis-grayoffblack p-0 m-0"}>
                          Signed in as
                        </p>
                        <p className={"text-axis-offblack p-0 m-0"}>
                          {user?.forename} {user?.surname}
                        </p>
                      </Dropdown.Item>
                      <Dropdown.Divider />
                      <Dropdown.Item
                        className={
                          "text-axis-offblack d-flex align-items-center"
                        }
                        as={Link}
                        to={{ pathname: `/users/${user?.id}` }}
                      >
                        <BsPersonFill className={"me-2"} />
                        My Profile
                      </Dropdown.Item>
                      <Dropdown.Divider />
                      <Dropdown.Item
                        className={
                          "text-axis-offblack d-flex align-items-center"
                        }
                        onClick={() => logout()}
                      >
                        <BiSolidLogOut className={"me-2"} />
                        Logout
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </header>

      <div
        id={"root-body"}
        className="flex-grow-1 d-flex"
        style={devProd ? { backgroundColor: "hotpink" } : null}
      >
        {!sidebarHidden && (
          <div className={"d-none d-md-block"} style={{ width: "305px" }}>
            <Sidebar buildVersion={buildVersion} user={user} />
          </div>
        )}
        <div id={"page-content-wrapper"} className="flex-grow-1 d-flex flex-column">
          <div className="flex-grow-1">
            {content}
          </div>
        </div>
      </div>

      <NavModal
        close={() => {
          setVisible(false);
        }}
        visible={visible}
        user={user}
      />

      <footer className="mt-auto py-2 text-center">
        <span>© {year} Axis Healthcare</span>
      </footer>
    </div>
  );
};
const BaseTemplate = (props) => (
  <LayoutProvider>
    <BaseTemplateInner {...props} />
  </LayoutProvider>
);

export default BaseTemplate;
